export default class DeviceHelper {
  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  isIosSafari() {
    const isSafari = !!navigator.userAgent.match(
      /^((?!Chrome|Android).)*Safari/
    );
    const iOS = this.isIOS();

    return isSafari && iOS;
  }
  /* istanbul ignore next */
  isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
}
